import { sendEvent as sendEventToYandexMetrika } from "./yandex-metrika";
import { sendEvent as sendEventToRybbit } from "./rybbit";

function sendEvent(event, id) {
  sendEventToRybbit(event, id);
  sendEventToYandexMetrika(event, id);
}

export { sendEvent };
